<script>
export default {
  name: 'ChangesList',
  props: ['changes'],
  computed: {
    list() {
      const list = [];

      for (let i in this.changes) {
        list.push({
          property: i,
          oldValue: this.changes[i].old,
          newValue: this.changes[i].new,
        });
      }

      return list;
    },
    title() {
      return this.list.map((item, i) => `${i + 1}. ${item.property}: ${item.oldValue} -> ${item.newValue}`).join('\n');
    },
  },
};
</script>

<template>
  <ol class="list" v-if="list.length > 0" :title="title">
    <li :key="item.property" v-for="item in list"><span class="property">{{ item.property }}</span>: <span class="old">{{ item.oldValue }}</span> -> <span>{{ item.newValue }}</span></li>
  </ol>
  <span v-else>-</span>
</template>


<style>
.list {
  margin: 0;
  padding: 0;
  text-align: left;
  max-width: 500px;
}

.list li {
  list-style-position: inside;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
}

.property {
  font-weight: bold;
}

.old {
  text-decoration: line-through;
}
</style>
